import { Button } from "@/components/ui/button";
import { Calendar } from "lucide-react";

export const ConsultationButton = () => {
  return (
    <Button
      onClick={() => window.open('https://cal.com/navisa-global/consultation', '_blank')}
      className="bg-secondary hover:bg-secondary/90 text-secondary-foreground"
      size="lg"
    >
      <Calendar className="w-4 h-4 mr-2" />
      Book Consultation
    </Button>
  );
};